// SPDX-FileCopyrightText: Copyright (c) 2025 Software GmbH, Darmstadt, Germany and/or its subsidiaries and/or its affiliates
// SPDX-FileContributor: Zead Alshukairi (planen-bauen 4.0 GmbH)
//
// SPDX-License-Identifier: Apache-2.0

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DIDEntry } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class DidService {

  dids: BehaviorSubject<DIDEntry[]> = new BehaviorSubject<DIDEntry[]>([]);

  constructor() { }

  setDIDs(dids: DIDEntry[]) {
    this.dids.next(dids);
  }

  getDIDs() {
    return this.dids.asObservable();
  }
}
